import Router         from './router'
import common         from './common'
import faq            from './faq'
import contact        from './contact'

import { createApp }    from 'vue'
import { createI18n }   from 'vue-i18n'
import { currentLang }  from '@/helpers'
import translations     from '../i18n/translation'
import registerLandlord from './register/registerLandlord.vue'
import registerCompany  from './register/registerCompany.vue'
import forgotPassword   from './reset/forgotPassword.vue'
import resetPassword    from './reset/resetPassword.vue'
import numberOfAvailableEstates    from './register/numberOfAvailableEstates.vue'
import estate           from '../internal/views/landlord/estate/estate.vue'
import showinterest     from '../internal/views/company/showInterest.vue'

const routes = {
    'common': {
        init: () => {
            const mountID = document.querySelector('#external-app')

            if (process.env.NODE_ENV !== 'production') {
                console.info('DOM-based routing mounted and ready to use!')
            }

            if (mountID) {
                // Vue instance
                const i18n = createI18n({
                    legacy: false,
                    globalInjection: true,
                    locale: currentLang,
                    messages: translations
                })

                const app = createApp({})

                app.use(i18n)

                // Register Components
                app.component('registerLandlord', registerLandlord)
                app.component('registerCompany', registerCompany)
                app.component('forgotPassword', forgotPassword)
                app.component('resetPassword', resetPassword)
                app.component('numberOfAvailableEstates', numberOfAvailableEstates)
                app.component('estate', estate)
                app.component('showinterest', showinterest)

                // Mount
                app.mount(`#${ mountID.id }`)
            }

            // Regular js
            common.init()
        }
    },
    'fragor-och-svar': {
        init: () => faq.init()
    },
    'faq': {
        init: () => faq.init()
    },
    'goda-rad': {
        init: () => faq.init()
    },
    'good-advice': {
        init: () => faq.init()
    },
    'trygghetskriterier-vid-uthyrning-till-foretag': {
        init: () => faq.init()
    },
    'approval-of-corporate-clients': {
        init: () => faq.init()
    },
    'kontakta-oss': {
        init: () => contact.init()
    },
    'contact-us': {
        init: () => contact.init()
    }
}

let router = new Router(routes)
router.load()